import { z } from 'zod';
import { requiredString } from '../helpers';
export const Call_Nice_Signal_1_ConfigValidator = z.object({
    connection: requiredString('Select a NiCE CXone connection'),
    signalParams: z.record(z.string(), z.unknown()).optional()
});
//# sourceMappingURL=call-nice-signal-1.js.map